<app-page-header [title]="'Language Details'" [subtitle]="'View details of the selected language'"></app-page-header>
<div class="mb-5">
    <h2>{{ language?.name }}</h2>
    <p><strong>ID:</strong> {{ language?.id }}</p>
    <p><strong>Locale Key:</strong> {{ language?.localeKey }}</p>
    <p><strong>Created By:</strong> {{ language?.createdBy | roleName }}</p>
    <p><strong>Updated By:</strong> {{ language?.updatedBy | roleName }}</p>
</div>
<div class="flex justify-between gap-2">
    <div>
        <p-button (click)="openEditDialog()" icon="pi pi-pencil" isAdmin label="Edit" text></p-button>
        <p-button (click)="confirmDelete()" icon="pi pi-trash" isAdmin label="Delete" severity="danger" text></p-button>
    </div>
    <p-button label="Back to Languages" icon="pi pi-arrow-left" routerLink="/languages"></p-button>
</div>

<!-- Update Dialog -->
<app-update-language-dialog
        [(visible)]="displayUpdateDialog"
        [language]="editableLanguage"
        (languageUpdated)="reloadLanguageDetails()"
></app-update-language-dialog>
